// 注文のキャンセル

import apiFactory from '../api-factory'

const V2_BASE_URL = process.env.VUE_APP_API_V2_BRIDGE_BASE_URL || '/api/v2-bridge'

export default apiFactory({
  path: `${V2_BASE_URL}/orders/<%= code %>/cancel`,
  method: 'POST',
  expectedParams: ['code'],
  needAuth: true,
})
